{
  "table": {
    "object": "Objet",
    "type": "Type",
    "message": "Message",
    "state": "État",
    "actions": "Actions",
    "createdAt": "Créé",
    "client": "Client",
    "userFirstName": "Prénom de l'utilisateur",
    "userLastName": "Nom de famille de l'utilisateur",
    "date": "Date",
    "amount": "Montant",
    "accountType": "Type de compte",
    "ticker": "Symbole",
    "currency": "Devise",
    "price": "Prix",
    "quantity": "Quantité",
    "organization": "Organisation",
    "processDate": "Date de traitement",
    "objectType": "Type d'objet",
    "effectiveDate": "Date d'entrée en vigueur",
    "settleDate": "Date de règlement",
    "custodianAccountNumber": "Numéro de compte du bénéficiaire",
    "clientName": "Nom du client",
    "transaction": "Transaction",
    "subTransaction": "Sous-transaction",
    "cusip": "CUSIP",
    "transactionDesc": "Description de la transaction",
    "transactionType": "Type de transaction",
    "commission": "Commission",
    "accruedInterest": "Intérêt accru",
    "securityType": "Type de valeur mobilière",
    "custodian": "Dépositaire(trice)",
    "account": "Compte",
    "flags": "Indicateurs",
    "systemUpdated": "Système mis à jour",
    "externalUpdated": "Mise à jour externe"
  },
  "state": "État",
  "exportProgressTitleFlags": "Exporter les indicateurs",
  "exportProgressTitleActivities": "Exporter les activités",
  "transactionType": "Type de transaction",
  "symbol": "Symbole",
  "custodianAccountNumber": "Numéro de compte du bénéficiaire",
  "type": "Type",
  "any": "Tous",
  "perPage": "Articles par page",
  "goTo": "Aller à",
  "tabs": {
    "flags": "Indicateurs",
    "activities": "Activités",
    "jobs": "Tâches"
  },
  "flagState": {
    "FLAGGED": "Signalé",
    "FIXED": "Terminé",
    "ALL_FIXED": "Marquer la sélection comme terminée",
    "ALL_RECONCILE": "Rapprocher tout",
    "ALL_FORCE_RECONCILE": "Forcer le rapprochement de tous",
    "TRIVIAL": "Trivial"
  },
  "activityState": {
    "CREATED": "Créé",
    "RECONCILED": "Rapproché",
    "RECONCILE": "Rapprocher",
    "FORCE_RECONCILE": "Forcer le rapprochement de tous"
  },
  "jobEventType": {
    "RECONCILIATION": "RAPPROCHEMENT"
  },
  "jobState": {
    "ANY": "TOUS",
    "INITIATED": "INITIÉ",
    "COMPLETED": "TERMINÉ",
    "FAILED": "ÉCHOUÉ"
  },
  "eventTable": {
    "eventType": "Type d'événement",
    "jobName": "Nom de la tâche",
    "ranAt": "Exécuté à",
    "updatedAt": "Mis à jour",
    "state": "État",
    "organization": "Organisation",
    "action": "Action"
  },
  "runReconciliation": {
    "title": "Exécuter le rapprochement",
    "reconcileActivities": "Activités de rapprochement",
    "updateCashAndHoldings": "Mettre à jour les liquidités et les actifs",
    "reconCashAndHoldings": "Rapprocher les liquidités et les actifs",
    "publishSnapshots": "Publier les instantanés",
    "runReconcileToastMessage": "Rapprochement demandé"
  },
  "accountSnapshot": {
    "security": "Sécurité",
    "systemQuantity": "Quantité",
    "externalQuantity": "Quantité externe",
    "diffQuantity": "Quantité différente",
    "systemPrice": "Prix",
    "externalPrice": "Prix externe",
    "diffPrice": "Prix différent",
    "systemValue": "Valeur système",
    "externalValue": "Valeur externe",
    "diffValue": "Valeur différente",
    "systemBookValue": "Valeur comptable",
    "externalBookValue": "Valeur comptable externe",
    "diffBookValue": "Valeur comptable différente",
    "ledger": "Grand livre",
    "transfers": "Transferts",
    "tradeOrders": "Ordres de transaction",
    "custodianActivities": "Activités externes",
    "total": "Total"
  },
  "jobDetails": {
    "title": "Détails supplémentaires pour {{jobName}} exécutée le {{ranAt}}"
  },
  "reconFlags": {
    "title": "Rapprochement",
    "summaryTitle": "Tableau de bord sommaire",
    "spotlight": {
      "negativeCash": {
        "title": "Compte de trésorerie négatif"
      },
      "negativeHolding": {
        "title": "Détention négative"
      },
      "holdingsMismatch": {
        "title": "Déséquilibre des détentions"
      },
      "moneyAvailableMismatch": {
        "title": "Déséquilibre des fonds disponibles"
      }
    },
    "totalFlags": "Total des indicateurs",
    "totalFlagsHint": "SIGNALÉS dans l'organisation",
    "unresolvedThreePlus": "Non résolus depuis 3 jours et plus",
    "unresolvedThreePlusHint": "SIGNALÉS, créés il y a plus de 3 jours",
    "severity": {
      "all": "Tous",
      "critical": "Critique",
      "high": "Élevée",
      "medium": "Moyenne",
      "low": "Faible"
    },
    "severityLabel": {
      "CRITICAL": "Critique",
      "HIGH": "Élevée",
      "MEDIUM": "Moyenne",
      "LOW": "Faible",
      "UNKNOWN": "Inconnue"
    },
    "filters": {
      "flagType": "Type d'indicateur",
      "category": "Catégorie",
      "aging": "Ancienneté",
      "any": "Tous",
      "agingOneDay": "1 jour et plus",
      "agingThreeDays": "3 jours et plus",
      "agingSevenDays": "7 jours et plus",
      "clearFilters": "Effacer les filtres",
      "priority": "Priorité"
    },
    "categories": {
      "snapshot": "Instantané",
      "warning": "Avertissement",
      "cashHoldings": "Compte de trésorerie et détentions",
      "activity": "Activité",
      "transfer": "Transfert",
      "account": "Compte",
      "product": "Produit"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Compte de trésorerie négatif",
      "NEGATIVE_HOLDING": "Détention négative",
      "DIFFERENT_HOLDINGS_V2": "Déséquilibre des détentions",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Déséquilibre des fonds disponibles"
    },
    "searchPlaceholder": "Rechercher par nom de client",
    "searchHelp": "Affiche les indicateurs pour un maximum de {{max}} comptes les plus pertinents. Affinez votre recherche si les résultats semblent incomplets.",
    "searchHelpAria": "À propos des limites de recherche de compte",
    "selection": {
      "count": "{{count}} exceptions sélectionnées",
      "selectAllOnPage": "Sélectionner tout sur la page",
      "clear": "Effacer la sélection",
      "dismiss": "Ignorer {{count}}",
      "dismissConfirmTitle": "Ignorer {{count}} indicateurs sélectionnés?",
      "dismissConfirmBody": "Ceci marquera les indicateurs sélectionnés comme résolus. Cette action ne peut pas être annulée à partir de cet écran.",
      "dismissConfirmAction": "Ignorer {{count}}"
    },
    "table": {
      "account": "Compte",
      "firstSeen": "Première apparition"
    },
    "agingDays_one": "{{count}} jour",
    "agingDays_other": "{{count}} jours",
    "drawer": {
      "close": "Fermer",
      "title": "Détail de l'indicateur",
      "fallbackTitle": "Détails de l'indicateur",
      "detailsHeading": "Détails",
      "summary": {
        "type": "Type :",
        "account": "Compte :",
        "date": "Date :",
        "firstSeen": "Première apparition :"
      },
      "followUpTask": "Créer une tâche de suivi",
      "resolve": "Résoudre",
      "resolveSuccess": "Indicateur résolu",
      "resolveError": "Impossible de résoudre cet indicateur",
      "tabs": {
        "overview": "Aperçu",
        "rawJson": "JSON brut",
        "notes": "Notes"
      },
      "sections": {
        "issueSummary": "Résumé du problème",
        "flagSummary": "Résumé de l'indicateur",
        "account": "Compte",
        "activity": "Activité et transfert dépositaire",
        "systemIdentifiers": "Identifiants système",
        "additional": "Détails supplémentaires"
      },
      "fields": {
        "flagType": "Type d'indicateur",
        "objectType": "Type d'objet",
        "priority": "Priorité",
        "created": "Créé",
        "state": "État",
        "custodianAcctShort": "Nº de compte dépositaire",
        "accountStatus": "Statut du compte",
        "transactionId": "ID de transaction",
        "subTransactionId": "ID de sous-transaction",
        "financialProductId": "ID de produit financier",
        "activityType": "Type",
        "activityStatus": "Statut",
        "firstSeen": "Première apparition"
      },
      "internalNotesHeading": "Notes internes",
      "notesLabel": "Notes",
      "notesPlaceholder": "Ajoutez des notes concernant votre enquête…",
      "notesSaved": "Notes enregistrées",
      "notesSaveError": "Impossible d'enregistrer les notes",
      "discardDraftConfirmTitle": "Jeter la note non enregistrée?",
      "discardDraftConfirmBody": "Vous avez une note qui n'a pas été enregistrée. Fermer sans enregistrer?",
      "discardDraftConfirmAction": "Jeter et fermer",
      "dismissSuccess": "Indicateur ignoré",
      "dismissError": "Impossible d'ignorer cet indicateur",
      "notesHistoryEmptyTitle": "Aucune note pour l'instant",
      "notesHistoryEmptyReadOnlyTitle": "Aucune note pour cet indicateur",
      "notesHistoryEmptyDescription": "Ajoutez une note pour saisir le contexte important concernant cet indicateur.",
      "addNote": "Ajouter une note"
    },
    "bulkDismissError": "Impossible d'ignorer les indicateurs sélectionnés",
    "bulkDismissSuccess": "{{count}} indicateurs ignorés",
    "bulkDismissPartial": "{{failed}} sur {{total}} indicateurs n'ont pas pu être ignorés",
    "bulkDismissNoFlaggedSelected": "Aucun des indicateurs sélectionnés ne peut être ignoré. Seuls les indicateurs signalés peuvent être résolus à partir de cette vue.",
    "emptyTable": "Aucun indicateur ne correspond aux filtres actuels.",
    "pagination": {
      "summary": "Affichage de {{start}}–{{end}} sur {{total}} indicateurs"
    },
    "flagState": {
      "FLAGGED": "Signalé",
      "FIXED": "Résolu",
      "TRIVIAL": "Ignoré"
    },
    "emptyTableHint": "Essayez d'ajuster vos filtres ou votre recherche.",
    "emptyTableNoResults": "Aucun indicateur trouvé.",
    "emptyTableNoData": "Aucune donnée disponible.",
    "agingHelp": "Jours depuis que ce problème a été <bold>observé pour la première fois</bold> (Première apparition). L'indicateur peut être actualisé quotidiennement lorsque le rapprochement réémet le même problème; cela ne <bold>réinitialise pas</bold> l'ancienneté. Résolvez ou ignorez lorsque le problème est corrigé.",
    "agingHelpAria": "À propos de la colonne d'ancienneté",
    "searchError": "La recherche de client a échoué. Veuillez réessayer."
  },
  "flagGlossary": {
    "title": "Glossaire des indicateurs",
    "openGlossary": "Glossaire",
    "backToFlags": "Retour aux indicateurs",
    "searchPlaceholder": "Rechercher des indicateurs",
    "loadError": "Impossible de charger le glossaire des indicateurs. Veuillez réessayer.",
    "emptyTable": "Aucun indicateur ne correspond aux filtres actuels.",
    "emptyTableHint": "Essayez d'ajuster vos filtres ou votre recherche.",
    "emptyTableNoResults": "Aucun indicateur trouvé.",
    "emptyTableNoData": "Aucune donnée de glossaire d'indicateurs disponible.",
    "emptyTableError": "Impossible de charger les indicateurs.",
    "emptyTableErrorHint": "Une erreur s'est produite. Veuillez réessayer.",
    "filters": {
      "category": "Catégorie",
      "clearFilters": "Effacer les filtres"
    },
    "kpi": {
      "total": "Total des indicateurs disponibles",
      "totalHint": "Tous les types d'indicateurs dans le glossaire",
      "thresholded": "Indicateurs à seuil",
      "thresholdedHint": "Indicateurs qui prennent en charge les seuils de montant ou de pourcentage",
      "turnedOff": "Désactivés",
      "turnedOffHint": "Types d'indicateurs désactivés pour cette organisation"
    },
    "table": {
      "flagName": "Nom de l'indicateur",
      "description": "Description",
      "exampleTrigger": "Exemple de déclencheur",
      "category": "Catégorie",
      "actualPriority": "Priorité actuelle",
      "actualThreshold": "Seuil actuel",
      "defaultPriority": "Priorité par défaut",
      "defaultThreshold": "Seuil par défaut"
    },
    "pagination": {
      "summary": "Affichage de {{start}}–{{end}} sur {{total}} types d'indicateurs"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "Une activité de transfert dans le fichier du dépositaire a une quantité, un prix et un symbole valides, mais le montant de la valeur comptable est invalide (par exemple, un transfert entrant nécessite une valeur comptable > 0; un transfert sortant nécessite une valeur comptable < 0).",
        "exampleTrigger": "Transfert entrant pour ABC a une quantité de 10 et un prix, mais bookValueAmountCents est 0 ou manquant → « SWI listé dans le fichier d'activité, mais le montant de la valeur comptable est invalide. »"
      },
      "FEE_NOT_FOUND": {
        "description": "Une activité de frais apparaît dans le flux du dépositaire, mais aucun transfert de retrait de frais correspondant n'a été trouvé sur la plateforme (à l'état DEMANDÉ).",
        "exampleTrigger": "Des frais de gestion de 25 $ apparaissent dans le fichier d'activité du dépositaire pour le compte, mais aucun transfert de frais correspondant n'existe sur la plateforme pour le rapprocher."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "Le montant de l'activité de frais du dépositaire ne correspond pas à la somme des transferts de retrait de frais DEMANDÉS de la plateforme (regroupés par source). Le service d'indicateurs peut supprimer en dessous d'un seuil en dollars (cents) configuré par l'organisation.",
        "exampleTrigger": "Les frais du dépositaire sont de 125,00 $ et la somme des retraits de frais de la plateforme est de 100,00 $ → l'indicateur est déclenché à moins que le seuil de l'organisation ne couvre l'écart de 25,00 $."
      },
      "TRADE_NOT_FOUND": {
        "description": "Une transaction apparaît dans le fichier d'activité du dépositaire, mais aucune transaction correspondante n'a été trouvée sur la plateforme pour la rapprocher.",
        "exampleTrigger": "L'activité du dépositaire montre un ACHAT de VOO, mais il n'y a aucune transaction EN COURS de traitement correspondante sur la plateforme."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "Une activité ou un enregistrement fait référence à un numéro de compte qui n'existe pas dans le système où il est censé être trouvé.",
        "exampleTrigger": "L'activité du dépositaire fait référence à un numéro de compte qui n'est pas enregistré sur la plateforme."
      },
      "TRANSFER_NOT_FOUND": {
        "description": "Une activité liée à un transfert apparaît dans le fichier d'activité du dépositaire (ou un règlement entrant n'a pas de candidats en cours), mais aucun transfert de plateforme correspondant n'a été trouvé.",
        "exampleTrigger": "Le dépositaire enregistre un règlement entrant de 10 000 $ et le sous-compte n'a pas de candidats de transfert externe DEMANDÉS/EN COURS → l'indicateur est déclenché. (D'autres chemins utilisent le même modèle « listé dans le fichier d'activité, mais introuvable ».)"
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "Un code ou type d'activité signalé par le dépositaire ou le système ne correspond à aucun type d'activité reconnu dans la configuration de mappage.",
        "exampleTrigger": "Le flux du dépositaire inclut le code d'activité « XYZ » sans mappage correspondant à un type d'activité connu."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "Une activité ou une détention fait référence à un produit financier (titre, fonds, etc.) qui n'existe pas dans le catalogue de produits.",
        "exampleTrigger": "Une transaction fait référence au CUSIP 123456789, mais aucun enregistrement de produit financier correspondant n'existe dans le système."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "Un type d'activité qui n'est attendu que sur les comptes d'entreprise a été trouvé enregistré sur un type de compte non corporatif.",
        "exampleTrigger": "Une activité d'action d'entreprise est enregistrée sur un compte imposable individuel au lieu d'un compte d'entreprise."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "Plus d'un enregistrement de transfert du dépositaire correspond aux détails d'un seul transfert entrant attendu, empêchant le rapprochement automatique.",
        "exampleTrigger": "Trois transferts distincts du dépositaire correspondent à la même référence de dépôt et au même montant, de sorte que le système ne peut pas résoudre automatiquement lequel s'applique."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "Une activité fait référence à une devise qui n'est pas activée ou prise en charge pour la connexion du dépositaire du compte.",
        "exampleTrigger": "Une transaction est libellée dans une devise qui n'a pas été activée pour cette connexion dépositaire."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "Une activité NSF est ignorée car un modèle de réinscription du dépositaire a été détecté : un EFT/CXLEFT apparié existe avec le même montant absolu, compte, date d'analyse et devise (souvent utilisé lorsque le dépositaire met à jour les codes de contributeur).",
        "exampleTrigger": "Un NSF de −$500 et un EFT de +$500 sont enregistrés sur le même compte et à la même date d'analyse → le NSF est ignoré et cet indicateur est déclenché."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "Une activité de retrait du RAP apparaît dans le fichier d'activité du dépositaire, mais aucun retrait utilisateur correspondant de la plateforme en COURS DE TRAITEMENT avec la raison « Régime d'accession à la propriété » n'a été trouvé (attendu sur les REER / REER de conjoint).",
        "exampleTrigger": "Le dépositaire affiche un retrait RAP de $35 000 sur un REER, mais la plateforme n'a aucun retrait RAP en COURS DE TRAITEMENT pour ce montant à rapprocher."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "Une activité NSF fait référence à un subTransactionId qui n'a aucune activité EFT ou de retrait interne (WDL) antérieure correspondante dans le flux du dépositaire pour ce compte et cette devise.",
        "exampleTrigger": "Un NSF de −$1 200 avec subTransactionId=ABC-99 est reçu, mais aucune activité EFT ou WDL avec ce subTransactionId n'existe → l'indicateur est déclenché."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "Un montant de règlement dépositaire entrant est en dehors de ±10 % de tous les transferts externes candidats en cours (DEMANDÉS/EN COURS DE TRAITEMENT) sur le sous-compte, de sorte que le rapprochement automatique est bloqué.",
        "exampleTrigger": "Le règlement est de $10 000 mais le seul candidat en cours est de $8 500 (15 % d'écart) → l'indicateur est déclenché pour un rapprochement manuel."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "Une ligne de transfert dans le fichier de tâche d'importation de transfert du dépositaire a été classée comme ÉCHOUÉE et n'a pas été importée avec succès.",
        "exampleTrigger": "Le fichier d'importation marque le transfert 64a1… comme ÉCHOUÉ → le message de l'indicateur fait référence à cette clé de fichier d'importation."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "Un transfert d'origine UTILISATEUR est resté en cours de traitement plus longtemps que le délai de service (SLA) de 2 jours ouvrables (basé sur le dernier changement d'état en « En cours de traitement »).",
        "exampleTrigger": "Un retrait UTILISATEUR est passé en cours de traitement le lundi et est toujours en cours de traitement le mercredi (2 jours ouvrables) → l'indicateur est déclenché."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "Un retrait UTILISATEUR est resté à l'état « Initié » pendant la période de service (SLA) de 3 jours ouvrables sans progresser.",
        "exampleTrigger": "Un retrait UTILISATEUR est passé à l'état « Initié » il y a exactement 3 jours ouvrables et est toujours à l'état « Initié » → l'indicateur est déclenché."
      },
      "TRANSFER_STUCK_READY": {
        "description": "Un transfert d'origine UTILISATEUR est resté à l'état « Prêt » plus longtemps que le délai de service (SLA) de 3 jours ouvrables, ou la soumission du dépositaire a renvoyé une raison d'échec qui déclenche le même type d'indicateur.",
        "exampleTrigger": "Un dépôt UTILISATEUR est à l'état « Prêt » depuis plus de 3 jours ouvrables sans progresser → l'indicateur est déclenché."
      },
      "FAILED_ACCOUNT": {
        "description": "La configuration ou l'approvisionnement du compte a échoué à un moment donné du processus et nécessite un suivi opérationnel pour être résolu.",
        "exampleTrigger": "La création du compte a été complétée sur la plateforme, mais l'intégration du dépositaire a renvoyé un statut d'échec."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "L'ouverture du compte dépositaire (ou, dans certains cas, la soumission du transfert) a renvoyé une liste de tâches en attente plutôt que de se terminer avec succès.",
        "exampleTrigger": "Le webhook d'ouverture de compte renvoie une liste de tâches en attente → FAILED_CUSTODIAN_OPENING est publié avec le message « L'ouverture du compte dépositaire a renvoyé une liste de tâches en attente. »"
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "La soumission de la demande d'ouverture de compte dépositaire a échoué (exception / ouverture infructueuse), de sorte qu'aucun compte dépositaire confirmé n'a été établi.",
        "exampleTrigger": "submitCustodianAccountOpening échoue avec un délai d'attente de connexion → indicateur « L'ouverture du compte dépositaire a échoué. »"
      },
      "ACCOUNT_CLOSED": {
        "description": "Le fichier EOD AccountInfo du dépositaire marque le compte comme FERMÉ (Statut=FERMÉ ou ClosedDate défini) alors que le compte de la plateforme est toujours actif (accès limité par fonctionnalité).",
        "exampleTrigger": "Le compte dépositaire 12345678 est FERMÉ dans AccountInfo; le compte de la plateforme est toujours ACTIF → « Le compte 12345678 est marqué comme FERMÉ par le dépositaire. »"
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "La valeur marchande du compte a chuté de plus de 15 % (par défaut) par rapport à l'instantané de rapprochement de la veille. Les augmentations sont ignorées.",
        "exampleTrigger": "La VM OneVest de la veille était de $100 000; celle du jour est de $80 000 (−20 %) avec un seuil par défaut de 15 % → l'indicateur est déclenché."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "Aucun relevé de compte n'a été trouvé pour le mois précédent pour un compte dépositaire qui a toujours une valeur marchande sur la plateforme.",
        "exampleTrigger": "Le compte 98765432 a une valeur marchande de $12 500 mais aucun relevé pour juin 2026 → l'indicateur est déclenché."
      },
      "CASH_NOT_FOUND": {
        "description": "Un solde de compte de trésorerie ou un poste de compte de trésorerie attendu n'a pas pu être localisé lors du rapprochement.",
        "exampleTrigger": "L'instantané du dépositaire inclut un solde de compte de trésorerie, mais la plateforme n'a aucun enregistrement de compte de trésorerie correspondant pour le compte."
      },
      "HOLDING_NOT_FOUND": {
        "description": "Le dépositaire signale une détention qui n'existe pas dans les registres de la plateforme pour ce compte.",
        "exampleTrigger": "Le dépositaire signale 200 actions de XYZ, mais la plateforme n'affiche aucune position pour ce symbole."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "Une détention existe dans les registres de la plateforme mais n'a pas été trouvée dans les détentions du dépositaire pour ce compte.",
        "exampleTrigger": "La plateforme affiche 100 actions de ABC, mais les détentions du dépositaire ne listent pas ce symbole."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "Après le rapprochement du compte de trésorerie, les fonds disponibles de la plateforme ne correspondent pas aux fonds disponibles de l'instantané du dépositaire (même devise). La publication peut être supprimée uniquement si une organisation configure un seuil en cents (ou en pourcentage); il n'y a pas de seuil par défaut de la plateforme.",
        "exampleTrigger": "Les fonds disponibles de la plateforme sont de $999,00 et l'instantané du dépositaire affiche $1 000,00 → l'indicateur est déclenché à moins que le seuil de l'organisation n'absorbe la différence de $1,00."
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "Après le rapprochement des détentions, la quantité de la plateforme pour un symbole ne correspond pas à la quantité du fichier de détention du dépositaire. La publication peut être supprimée uniquement si une organisation configure un seuil en pourcentage; il n'y a pas de pourcentage par défaut de la plateforme.",
        "exampleTrigger": "Le fichier de détention affiche 100 actions de XYZ et la plateforme en affiche 90 → l'indicateur est déclenché à moins que le seuil en pourcentage de l'organisation ne permette cet écart."
      },
      "NEGATIVE_CASH": {
        "description": "Le solde du compte de trésorerie d'un compte est tombé en dessous de zéro.",
        "exampleTrigger": "La position du compte de trésorerie d'un compte est négative après le règlement d'une transaction."
      },
      "NEGATIVE_HOLDING": {
        "description": "Une position de valeur mobilière affiche une quantité négative d'actions ou d'unités.",
        "exampleTrigger": "La quantité de détentions pour un symbole est enregistrée comme étant inférieure à zéro."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Identique à « Fonds disponibles V2 », mais la comparaison utilise les fonds disponibles ajustés pour les transactions en attente.",
        "exampleTrigger": "Après ajustement pour les transactions en attente, les fonds disponibles de la plateforme sont de $5 000 mais l'instantané du dépositaire implique $5 200 → l'indicateur est déclenché (sous réserve de la passerelle de l'organisation)."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Identique à « Déséquilibre des détentions V2 », mais les quantités sont ajustées pour les transactions en attente avant la comparaison.",
        "exampleTrigger": "Après les ventes en attente, la plateforme prévoit 50 actions de ABC mais le fichier du dépositaire en affiche toujours 60 → l'indicateur est déclenché (sous réserve de la passerelle de l'organisation)."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "La valeur comptable sur le fichier de détention du dépositaire diffère de la valeur comptable de la plateforme pour un symbole (uniquement lorsque les indicateurs de valeur comptable sont activés). Peut être limitée par un seuil en cents de l'organisation.",
        "exampleTrigger": "La valeur comptable du fichier de détention est de $1 000 et la valeur comptable de la plateforme est de $1 050 pour ABC → l'indicateur est déclenché lorsque la fonctionnalité est activée."
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "Aucun SubAccountDailyStats (instantanés quotidiens de l'historique) n'a été reçu pour la date prévue.",
        "exampleTrigger": "Pour le 21/07/2026, l'historique a zéro lignes de statistiques quotidiennes → « Aucun instantané quotidien reçu pour le 21/07/2026. »"
      },
      "SNAPSHOT_MISSING": {
        "description": "Un instantané quotidien de la veille existe pour un sous-compte, mais la ligne SubAccountDailyStats d'aujourd'hui est manquante.",
        "exampleTrigger": "Le sous-compte avait des statistiques hier, mais aucune pour le 21/07/2026 → « Instantané manquant pour le sous-compte {id} 21/07/2026. »"
      },
      "SNAPSHOT_ANOMALY": {
        "description": "Les champs de contribution de l'instantané quotidien sont incohérents : sur le premier instantané, la valeur marchande / la contribution nette / la nouvelle contribution sont inégales par paires; sinon, newContributionCents n'est pas égal au changement quotidien de la contribution nette.",
        "exampleTrigger": "La contribution nette d'hier était de 1 000 $ et celle d'aujourd'hui est de 1 100 $, mais newContributionCents est de 50 $ (pas 100 $) → l'indicateur est déclenché."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "Un prix du marché nécessaire pour évaluer une position dans un instantané n'a pas pu être localisé pour cette date.",
        "exampleTrigger": "Un instantané liste le symbole XYZ, mais aucun prix du marché n'est disponible pour la date de l'instantané."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "Un retrait total ne peut pas être traité car les fonds disponibles sur le compte (après avoir additionné les soldes disponibles négatifs) sont insuffisants.",
        "exampleTrigger": "Le retrait total cible 5 000 $ mais d'autres sous-comptes contribuent à −6 000 $ disponibles → « Le retrait total ne peut pas être traité en raison d'un manque de fonds disponibles sur un compte. »"
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "Pour une transaction de vente totale de fonds communs de placement, la quantité attendue par rapport à la quantité d'activité du dépositaire diffère d'au moins 10 % (l'organisation doit autoriser la logique des transactions en attente; le pourcentage par défaut du service d'indicateurs est de 10 %).",
        "exampleTrigger": "La vente totale prévoit une quantité de 100, mais la quantité d'activité est de 85 (écart de 15 %) → l'indicateur est déclenché."
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "Pour une transaction d'ETF en USD, la valeur attendue par rapport à la valeur d'activité (quantité × prix) diffère d'au moins 10 % (même condition que la vente totale de fonds communs de placement).",
        "exampleTrigger": "La transaction a alloué 10 000 $, mais la valeur de remplissage est de 8 500 $ (écart de valeur de 15 %) → l'indicateur est déclenché."
      }
    }
  },
  "flagsMovedModal": {
    "title": "Les indicateurs ont été déplacés",
    "body": "Les indicateurs se trouvent maintenant dans leur propre tableau de bord avec de nouveaux filtres, des résumés et une vue détaillée. Vous y serez redirigé maintenant.",
    "confirm": "Aller aux indicateurs"
  },
  "activitiesMovedModal": {
    "title": "Les activités ont été déplacées",
    "body": "Les activités se trouvent maintenant dans leur propre tableau de bord avec des métriques et une liste de travail repensée. Vous y serez redirigé(e) maintenant.",
    "confirm": "Aller aux activités"
  },
  "activitiesV3": {
    "pageTitle": "Activités",
    "pageSubtitle": "Surveillez les métriques de rapprochement des activités du dépositaire et le carnet de commandes.",
    "tablePlaceholder": "La liste de travail des activités sera bientôt disponible",
    "chartSlot": {
      "placeholder": "Le graphique d'ancienneté du carnet de commandes sera bientôt disponible"
    },
    "metrics": {
      "error": "Impossible de charger les métriques d'activité.",
      "occurringToday": {
        "title": "Se produisant aujourd'hui",
        "hint": "Activités se produisant aujourd'hui (UTC)"
      },
      "created": {
        "title": "Créées",
        "hint": "Carnet de commandes en attente (tous les temps)"
      },
      "reconciledToday": {
        "title": "Rapprochées aujourd'hui",
        "hint": "Rapprochées aujourd'hui (UTC)"
      },
      "agingPending": {
        "title": "Ancienneté en attente",
        "hint": "En attente depuis 3 jours et plus (UTC)"
      }
    },
    "filters": {
      "state": "État",
      "stateCreated": "Créées",
      "stateReconciledToday": "Rapprochées (aujourd'hui)",
      "aging": "Ancienneté",
      "any": "Tous",
      "agingOneDay": "1 jour et plus",
      "agingThreeDays": "3 jours et plus",
      "agingSevenDays": "7 jours et plus",
      "search": "Rechercher",
      "searchPlaceholder": "Client, numéro de compte ou symbole",
      "clearFilters": "Effacer les filtres",
      "expandAll": "Tout développer",
      "collapseAll": "Tout réduire",
      "type": "Catégorie"
    },
    "table": {
      "organization": "Organisation",
      "custodianAcct": "Compte dépositaire",
      "amount": "Montant",
      "acctType": "Type de compte",
      "ticker": "Symbole",
      "state": "État",
      "aging": "Ancienneté",
      "reconciledVia": "Rapproché via",
      "empty": "Aucune activité ne correspond aux filtres actuels.",
      "detailPlaceholder": "Le détail de l'activité sera bientôt disponible",
      "client": "Nom du client",
      "date": "Date de l'activité",
      "type": "Catégorie"
    },
    "bulk": {
      "selectedCount": "{{count}} sélectionné(e)s",
      "selectAllOnPage": "Sélectionner tout sur la page",
      "clearSelection": "Effacer la sélection",
      "retry": "Nouvel essai en masse"
    }
  }
}
